import src from "IMAGE";
export default { src, width: 183, height: 54, blurWidth: 0, blurHeight: 0};
